import * as React from "react";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

const SelectCategory = ({
  value,
  renderInputLabelColor,
  renderInputLabelFontSize,
  renderInputLabelFontStyle,
  renderInputLabelFontFamily,
  renderInputLabelFontWeight,
  heading,
  requireCategory,
  renderInputFieldTextColor,
  renderInputFieldBGColor,
  renderInputFieldBorderColor,
  renderInputFieldBorderRadius,
  previewAgent,
  handleCatChange,
  feedbackType,
  productParams,
}: any) => {
  return (
    <Typography sx={{ mt: 1 }}>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          margin: "15px 0 8px",
          color: renderInputLabelColor(),
          fontSize: renderInputLabelFontSize(),
          fontStyle: renderInputLabelFontStyle(),
          fontFamily: renderInputLabelFontFamily(),
          fontWeight: renderInputLabelFontWeight(),
        }}
      >
        {` ${heading()} ${requireCategory()}`}
      </InputLabel>
      <FormControl fullWidth>
        <Select
          className="noborder feedback-input"
          sx={{
            color: renderInputFieldTextColor(),
            backgroundColor: renderInputFieldBGColor(),
            border: "1px solid" + renderInputFieldBorderColor(),
            borderRadius: renderInputFieldBorderRadius(),
            "& input": {
              fontSize: previewAgent ? "14px!important" : "11px!important",
              fontFamily: `${renderInputLabelFontFamily()}!important`,
            },
            "& .MuiSelect-select": {
              padding: "0!important",
            },
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          }}
          value={value}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          onChange={(event) => handleCatChange(event)}
        >
          <MenuItem value="" disabled>{`Select a Category ${
            productParams.productParams.products[0].feedbackAgentSettings?.[
              feedbackType
            ]?.reqCategory == true
              ? "*"
              : ""
          }`}</MenuItem>
          {productParams.productParams.products[0].feedbackAgentSettings?.[
            feedbackType
          ]?.categories.map((val: any, index: any) => (
            <MenuItem value={val.name}>{val.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Typography>
  );
};

export default SelectCategory;
